import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { AuFileNameComponent } from '../../../../../../shared/ui-components/au-file-name/au-file-name.component';

import { MatIcon } from '@angular/material/icon';
import { AuDocumentTypeComponent } from '../../../../../../shared/ui-components/au-document-type/au-document-type.component';
import { AuExpandableTagsComponent } from '../../../../../../shared/ui-components/au-expandable-tags/au-expandable-tags.component';
import { AvatarWithNameComponent } from '../../../../../../shared/ui-components/au-avatar-with-name/avatar-with-name.component';
import { DateAgoPipe } from '@shared/pipes/date-ago.pipe';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'file-card',
	templateUrl: './file-card.component.html',
	styleUrls: ['./file-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatCheckbox,
		AuFileNameComponent,
		MatIcon,
		AuDocumentTypeComponent,
		AuExpandableTagsComponent,
		AvatarWithNameComponent,
		DateAgoPipe,
		NgxTolgeeModule,
	],
})
export class FileCardComponent {
	@Input() file;
	@Input() fileSelected: boolean;
	@Input() allowDelete = true;
	@Output() deletePressed = new EventEmitter<void>();
	@Output() openFile = new EventEmitter<any>();
	@Output() selectionChange = new EventEmitter<any>();
}
